import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "App Development Foundations & Mobile Ecosystem",
    description:
      "Understanding mobile platforms (Android, iOS), Native vs Hybrid vs Cross-platform apps, App development lifecycle, UI/UX principles for mobile apps, Industry use cases & real applications",
  },
  {
    title: "Programming Fundamentals for App Builders",
    description:
      "Basics of programming logic, Variables, loops, conditions, functions, Data structures & algorithms basics, Coding best practices for scalable apps, Hands-on exercises for logical thinking",
  },
  {
    title: "Frontend Development with Flutter / React Native",
    description:
      "Understanding cross-platform development, Widgets, Components & UI building, Navigation & routing, State management (Provider, Redux, Context), Integrating APIs & dynamic data",
  },
  {
    title: "Backend Development & API Integration",
    description:
      "Node.js / Firebase backend basics, REST APIs & JSON data, Authentication & user management, Realtime data with Firebase/Firestore, Securing API calls & data flow",
  },
  {
    title: "Database Management for Mobile Applications",
    description:
      "Local storage (SQLite, Hive, Room DB), Cloud databases (Firebase, Supabase), CRUD operations, Offline functionality in apps, Data syncing & caching strategies",
  },
  {
    title: "UI/UX for Mobile Apps & Interactive Design",
    description:
      "Wireframing & prototyping, Color theory & typography for mobile, Layout structure & responsive design, Animation & micro-interactions, Creating user-friendly intuitive interfaces",
  },
  {
    title: "App Testing, Debugging & Performance Optimization",
    description:
      "Manual & automated testing, Debugging tools & error handling, Optimizing app performance, Memory battery & network usage improvement, Ensuring app stability across devices",
  },
  {
    title: "Deployment & Publishing on App Stores",
    description:
      "Preparing apps for Play Store & App Store, Signing bundling & versioning, Store listing screenshots & descriptions, App approval guidelines & policies, Post-launch monitoring & updates",
  },
  {
    title: "Advanced App Features & Integrations",
    description:
      "Push notifications, Payment gateway integration, Location maps & sensor usage, Camera media & storage access, AI/ML powered features .",
  },
  {
    title: "Capstone App Project & Career Preparation",
    description:
      "Building a complete production-ready app, End-to-end development: frontend + backend + deployment, GitHub portfolio creation, Resume building for App Developer roles, Interview prep (Flutter, React Native, Android)",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
